// extracted by mini-css-extract-plugin
export default {"root":"ApplicationFrame_root__0cXho","main":"ApplicationFrame_main__4gAxl","content":"ApplicationFrame_content__NWbb8"};